export const getAbsoluteCoords = (coords_rel, size) => {
	let abs_coords = {};

	for(const coord in coords_rel) {
		abs_coords[coord] = coords_rel[coord] * size;
	}

	return abs_coords;
};

export const getRelativeCoords = (coords_abs, size) => {
	let rel_coords = {};

	for(const coord in coords_abs) {
		rel_coords[coord] = coords_abs[coord] / size;
	}

	return rel_coords;
};

export const getAbsoluteCoordsAsymmetrical = (coords_rel, size_w, size_h) => {
	let abs_coords = {...coords_rel};

	for(const coord in coords_rel) {
		switch(coord) {
			case 'w':
			case 'x':
				abs_coords[coord] = coords_rel[coord] * size_w;
				break;

			case 'h':
			case 'y':
				abs_coords[coord] = coords_rel[coord] * size_h;
				break;
		}
	}

	return abs_coords;
};

export const getRelativeCoordsAsymmetrical = (coords_abs, size_w, size_h) => {
	let rel_coords = {...coords_abs};

	for(const coord in coords_abs) {
		switch(coord) {
			case 'w':
			case 'x':
				rel_coords[coord] = coords_abs[coord] / size_w;
				break;

			case 'h':
			case 'y':
				rel_coords[coord] = coords_abs[coord] / size_h;
				break;
		}
	}

	return rel_coords;
};

export const calcImageSize = (w, h, max_w, max_h, type = 'cover') => {
	const w_prop = (max_w + 1) / w;
	const h_prop = (max_h + 1) / h;

	if(type == 'contain') return Math.min(w_prop, h_prop);

	return Math.max(w_prop, h_prop);
};

export const calcItemOffset = (item, max_w, max_h, _size) => {
	return {
		x:(_size * item.w - max_w) / 2,
		y:(_size * item.h - max_h) / 2,
	};
};

export const adaptImageSizes = (image, item_size, default_w, default_h) => {
	const max_w = (!image.use_full_size) ? item_size : default_w;
	const max_h = (!image.use_full_size) ? item_size : default_h; 

	const _scale = calcImageSize(image.image_w, image.image_h, max_w, max_h, image.fit);
	const _offset = calcItemOffset({ w:image.image_w, h:image.image_h }, item_size, item_size, _scale);
	return { ...image, scale:_scale, offset:_offset };
};